import { Chip } from "@mui/material"

export const UIAppVersion = () => {
  return (
    <Chip
      label={process.env.REACT_APP_VERSION}
      size="small"
      color="primary"
      variant="outlined"
      sx={{ padding: "0.5rem", border: "none", position: "fixed", bottom: "0", right: "0" }}
    />
  )
}
